<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  assistant: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const MODEL_OPTIONS = [
  { value: 'gpt-4o-mini', key: 'GPT_4O_MINI' },
  { value: 'gpt-5.1', key: 'GPT_5_1' },
  { value: 'gpt-5.2', key: 'GPT_5_2' },
];

const DEFAULT_MODEL = 'gpt-5.1';

const selectedModel = ref(DEFAULT_MODEL);
let initialModel = DEFAULT_MODEL;

const isDirty = computed(() => selectedModel.value !== initialModel);

const getPayload = () => ({ config: { model: selectedModel.value } });

defineExpose({ getPayload, isDirty });

watch(
  () => props.assistant,
  newAssistant => {
    if (!newAssistant) return;
    selectedModel.value = newAssistant.config?.model || DEFAULT_MODEL;
    initialModel = selectedModel.value;
  },
  { immediate: true }
);
</script>

<template>
  <div class="grid grid-cols-1 gap-3 md:grid-cols-3" role="radiogroup">
    <button
      v-for="option in MODEL_OPTIONS"
      :key="option.value"
      type="button"
      role="radio"
      :aria-checked="selectedModel === option.value"
      class="flex flex-col gap-1 p-4 text-start rounded-xl border transition-colors"
      :class="
        selectedModel === option.value
          ? 'border-n-brand bg-n-brand/5'
          : 'border-n-weak bg-n-solid-1 hover:border-n-strong'
      "
      @click="selectedModel = option.value"
    >
      <span class="text-sm font-medium text-n-slate-12">
        {{ t(`CAPTAIN.ASSISTANTS.FORM.MODEL.OPTIONS.${option.key}.NAME`) }}
      </span>
      <span class="text-xs text-n-slate-11">
        {{
          t(`CAPTAIN.ASSISTANTS.FORM.MODEL.OPTIONS.${option.key}.DESCRIPTION`)
        }}
      </span>
    </button>
  </div>
</template>
